import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const adminService = {
  getDashboardStatistics: async () => {
    const response = await axios.get(`${API_BASE_URL}/admin/dashboard/statistics`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getBookingReport: async (reportData) => {
    const response = await axios.post(`${API_BASE_URL}/admin/reports/booking`, reportData, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getRevenueReport: async (reportData) => {
    const response = await axios.post(`${API_BASE_URL}/admin/reports/revenue`, reportData, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getConfigurations: async () => {
    const response = await axios.get(`${API_BASE_URL}/admin/configurations`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  createConfiguration: async (configData) => {
    const response = await axios.post(
      `${API_BASE_URL}/admin/configurations`,
      configData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  updateConfiguration: async (key, configData) => {
    const response = await axios.put(
      `${API_BASE_URL}/admin/configurations/${key}`,
      configData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  getAllModules: async () => {
    const response = await axios.get(`${API_BASE_URL}/admin/modules`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  updateModuleStatus: async (id, statusData) => {
    const response = await axios.put(
      `${API_BASE_URL}/admin/modules/${id}/status`,
      statusData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },
};

export default adminService;

